/* Native scrolling works without JavaScript; this only connects the arrows. */
try {
  if (!customElements.get('mp-opiniones-carousel')) {
    customElements.define('mp-opiniones-carousel', class extends HTMLElement {
      connectedCallback() {
        try {
          const track = this.querySelector('.mp-opiniones__track');
          this.querySelectorAll('[data-direction]').forEach((button) => {
            button.onclick = () => {
              try {
                const card = track.querySelector('li');
                const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap);
                track.scrollBy({
                  left: Number(button.dataset.direction) * step,
                  behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
                });
              } catch (_) {}
            };
          });
        } catch (_) {}
      }
    });
  }
} catch (_) {}
